var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBarrier(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 24,
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 20.3 13.7",
    style: {
      enableBackground: "new 0 0 20.3 13.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#C52036;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1.7,
    y: 3.3,
    className: "st0",
    width: 16.7,
    height: 2.4
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "3.2,3.3 3.2,1.4 6,1.4 6,3.3  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "6,5.7 6,12.2 3.2,12.2 3.2,5.7  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 10,
    y1: 3.3,
    x2: 10,
    y2: 5.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 7.1,
    y1: 3.3,
    x2: 7.1,
    y2: 5.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 13,
    y1: 3.6,
    x2: 13,
    y2: 5.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 15.9,
    y1: 3.3,
    x2: 15.9,
    y2: 5.7
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarrier);
export default __webpack_public_path__ + "static/media/barrier.08976e07.svg";
export { ForwardRef as ReactComponent };